import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMiter = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon-join-miter",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7 15H4V4h11v3H7v8z"
	})
});
export default SvgMiter;
